import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CreditNoteComponent } from './components/credit-note/credit-note.component';
import { ServiceListComponent } from './components/service-list/service-list.component';
import { CoreModule } from '@app/core/core.module';
import { TaxbreakdownComponent } from './components/taxbreakdown/taxbreakdown.component';

@NgModule({
  // tslint:disable-next-line:max-line-length
  declarations: [CreditNoteComponent, ServiceListComponent, TaxbreakdownComponent],
  imports: [
    CoreModule,
    CommonModule,
    RouterModule.forChild([
      { path: '', component: CreditNoteComponent }
    ]),
  ]
})
export class CreditNoteModule { }
